<!-- Receipt -->
<script>
import Errors from "../shared/components/errors-page/errors.vue";
import Loader from "../shared/components/loader/loader.vue";
import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";
import receiptDesign from './receiptDesign'
import downloadSvg from '../shared/components/downloadSvg.vue'
export default {
  data() {
    return {
      networkError: false,
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      receiptDetails: {},
      isLoading: true,
      showLoader: false
    };
  },
  components: {
    Errors,
    Loader,
    receiptDesign,
    downloadSvg
  },
  computed: {
    getSubtotal () {
      let subtotal = 0
      if (this.receiptDetails.managers) {
        this.receiptDetails.managers.forEach(val => {
          subtotal += val.funded_dollars
        })
      }
      let number_format;
      return Number(subtotal).toLocaleString(number_format, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  },
  methods: {
    async exportToPDF() {
      let elem = document.getElementById("document").innerHTML
      let opt = {
        margin: 1,
        filename: `receipt.pdf`,
        image: { type: "png", quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
        jsPDF: { format: [918.00, 1162.5] },
      }
      return html2pdf().from(elem).set(opt).save();
    },
    backPage() {
      this.$router.push("/transactions");
    },
    async gotoDownloadReceipt() {
      this.showLoader = true
      await this.exportToPDF()
      this.showLoader = false
    },
  },
  created() {
    if (navigator.onLine) {
      this.networkError = false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError = true;
    }
    const transactionId = this.$route.params.id;
    axios
      .get(
        `${process.env.VUE_APP_API_URL}/Transaction/details?transactionId=${transactionId}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        res.data.created_at = moment(res.data.created_at).format("DD/MM/YYYY");
        this.receiptDetails = res.data;
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.data.error.status === 401) {
          this.error = true;
          this.error401 = true;
        } else if (error.response.data.error.status === 500) {
          this.error = true;
          this.error500 = true;
        } else {
          this.error = true;
          this.errorOther = true;
        }
      });
  },
};
</script>

<!-- Template -->
<template>
  <fragment>
    <div v-if="!error" class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-12 offset-md-0 px-0" v-if="!isLoading">
          <!-- Header --Start -->
          <div class="row button-container hide-on-mob">
            <div class="col-4">
              <b-button
                @click="backPage()"
                class="back-button btn-ripple"
                variant="outline-light"
              >
                <img class="arrow" src="../../assets/arrow.svg" alt />
                {{ $tc("message.backAndNext", 1) }}
              </b-button>
            </div>
            <div class="col-4 text-center">
              <h2 class="receipt-title">
                {{ $tc("message.receiptHeaderTitle") }}
              </h2>
            </div>
          </div>

          <div class="mobileVisible">
            <div class="button-container-mobile">
              <div class="pr-2">
                <b-button
                  @click="backPage()"
                  class="back-button btn-ripple p-0 m-0"
                  variant="outline-light"
                >
                  <img class="arrow" src="../../assets/arrow.svg" alt />
                  {{ $tc("message.backAndNext", 1) }}
                </b-button>
              </div>
              <div class="text-center p-0">
                <h2 class="receipt-title-mobile m-0 p-0">
                  {{ $tc("message.receiptHeaderTitle") }}
                </h2>
              </div>
              <!-- Download button -->
              <div class="text-right">
                <b-button
                  class="download-button-mobile col-6 bg-warning border-warning"
                  variant="warning"
                  @click="gotoDownloadReceipt"
                >
                  <img
                    class="downloadimg-mobile"
                    src="../../assets/download.svg"
                    alt
                  />
                </b-button>
              </div>
            </div>
          </div>
          <!-- Header Ends -->

          <div class="receipt-container bg-light">
            <!-- header details container start -->
            <div class="hide-on-mob">
              <div class="main-header-section bg-white">
                <div
                  class="col-lg-6 col-md-4 col-sm-4 px-0 hide-on-mob"
                >
                  <h4 class="purchased-date-text mb-0">
                    {{ $tc("message.receiptDetailTitle", 0) }}:
                    {{ receiptDetails.created_at }}
                  </h4>
                </div>
                <div class="col-lg-6 col-md-8 col-sm-8 text-right hide-on-mob pr-0">
                  <p class="mb-0 paypal-text text-secondary">
                    {{ $tc("message.receiptDetailTitle", 1) }}:
                    {{ receiptDetails.payment_external_id }}
                  </p>
                  <p class="mb-0 purchased-by-text text-secondary">
                    {{ $tc("message.receiptDetailTitle", 2) }}:
                    {{ receiptDetails.buyer_name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mobileVisible">
              <div class="main-header-section-mobile bg-white">
                <div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 pl-0">
                  <h4 class="purchased-date-text-mobile mb-0">
                    {{ $tc("message.receiptDetailTitle", 0) }}:
                    {{ receiptDetails.created_at }}
                  </h4>
                </div>
                <div class="col-12 px-0">
                  <p class="mt-3 paypal-text text-secondary">
                    {{ $tc("message.receiptDetailTitle", 1) }}:
                    {{ receiptDetails.payment_external_id }}
                  </p>
                  <p class="mb-0 purchased-by-text text-secondary">
                    {{ $tc("message.receiptDetailTitle", 2) }}:
                    {{ receiptDetails.buyer_name }}
                  </p>
                </div>
                <!-- header details container Ends -->

                <!-- mobile view summary  start -->
                <div class="col px-0 mobileVisible">
                  <div class="order-summary-container-mobile bg-white p-0">
                    <div
                      class="mb-2"
                      v-for="(managers, index) in receiptDetails.managers"
                      :key="index"
                    >
                      <div class="restaurant-detail">
                        <div class="owner-name-title-mobile">
                          <p class="mb-0">
                            {{ managers.recipient_first_name }}
                            {{ managers.recipient_last_name }}
                          </p>
                        </div>
                        <div class="order-price-value">
                          <p class="mb-0">
                            ${{
                              Number(managers.funded_dollars).toLocaleString()
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="restaurant-points-detail border-bottom">
                        <div class="restaurant-name-title text-secondary">
                          <p class="mb-0">
                            {{ $tc("message.receiptSummarytitles", 1) }}:
                            {{ managers.recipient_department_name }}
                          </p>
                        </div>
                        <div class="restaurant-point-value text-right">
                          <p class="mb-0">
                            ({{
                              Number(managers.funded_points).toLocaleString()
                            }}) pts
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 px-0 mobileVisible">
                  <div class="row justify-content-end">
                    <div class="col-7 pl-0">
                      <div class="sub-total-detail-mobile">
                        <div class="sub-total-title-mobile text-secondary">
                          <p class="mb-0">
                            {{ $tc("message.receiptSummarytitles", 2) }}
                          </p>
                        </div>
                        <div class="sub-total-value-mobile">
                          <p class="mb-0">
                            ${{ getSubtotal }}
                          </p>
                        </div>
                      </div>
                      <div class="fees-detail">
                        <div class="fees-title-mobile text-secondary">
                          <p class="mb-0">
                            {{ $tc("message.receiptSummarytitle", 0) }}
                          </p>
                        </div>
                        <div class="fees-value-mobile">
                          <p class="mb-0">
                            ${{
                              receiptDetails.service_fee | formatNumber
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="taxes-detail border-bottom">
                        <div class="taxes-title-mobile text-secondary">
                          <p class="mb-0">
                            {{ $tc("message.receiptSummarytitle", 1) }}
                          </p>
                        </div>
                        <div class="taxes-value-mobile">
                          <p class="mb-0">
                            ${{ receiptDetails.tax | formatNumber }}
                          </p>
                        </div>
                      </div>

                      <div class="total-cost-detail">
                        <div class="total-cost-title-mobile text-secondary">
                          <p class="mb-0">
                            {{ $tc("message.receiptSummarytitle", 2) }}
                          </p>
                          <p class="mb-0">
                            {{
                              Number(
                                receiptDetails.total_points
                              ).toLocaleString()
                            }}pts
                          </p>
                        </div>
                        <div class="cost-value-mobile text-success">
                          <h3 class="mb-0">
                            ${{
                              receiptDetails.total | formatNumber
                            }}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- mobile view summary  ends -->
              </div>
            </div>

            <div class="summary-wrapper col-lg-12">
              <!-- Oder summary start -->
              <div class="hide-on-mob summary-card col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="order-summary-container bg-white">
                  <h4 class="order-summary-title mb-0">
                    {{ $tc("message.summaryTitles", 0) }}
                  </h4>
                  <div
                    class="mb-2"
                    v-for="(managers, index) in receiptDetails.managers"
                    :key="index"
                  >
                    <div class="restaurant-detail">
                      <div class="owner-name-title pr-3">
                        <p class="mb-0">
                          {{ managers.recipient_first_name }}
                          {{ managers.recipient_last_name }}
                        </p>
                      </div>
                      <div class="order-price-value">
                        <p class="mb-0">
                          ${{
                            Number(managers.funded_dollars).toLocaleString()
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="restaurant-points-detail border-bottom">
                      <div class="restaurant-name-title pr-3">
                        <p class="mb-0">
                          {{ $tc("message.receiptSummarytitles", 1) }}:
                          {{ managers.recipient_department_name }}
                        </p>
                      </div>
                      <div class="restaurant-point-value text-right">
                        <p class="mb-0">
                          {{ Number(managers.funded_points).toLocaleString() }}
                          pts
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Order summarey ends-->

              <!-- Payments summary start -->
              <div class="hide-on-mob col-lg-6 col-md-6 col-sm-6 summary-card">
                <div class="payment-summary-container bg-white">
                  <h4 class="payment-summary-title mb-0">
                    {{ $tc("message.summaryTitles", 1) }}
                  </h4>
                  <div class="sub-total-detail">
                    <div class="sub-total-title text-secondary pr-2">
                      <p class="mb-0">
                        {{ $tc("message.receiptSummarytitles", 2) }}
                      </p>
                    </div>
                    <div class="sub-total-value">
                      <p class="mb-0">
                        ${{ getSubtotal }}
                      </p>
                    </div>
                  </div>
                  <div class="fees-detail">
                    <div class="fees-title text-secondary pr-2">
                      <p class="mb-0">
                        {{ $tc("message.receiptSummarytitle", 0) }}
                      </p>
                    </div>
                    <div class="fees-value">
                      <p class="mb-0">
                        ${{
                          receiptDetails.service_fee | formatNumber
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="taxes-detail border-bottom pt-0">
                    <div class="taxes-title text-secondary pr-2">
                      <p class="mb-0">
                        {{ $tc("message.receiptSummarytitle", 1) }}
                      </p>
                    </div>
                    <div class="taxes-value">
                      <p class="mb-0">
                        ${{ receiptDetails.tax | formatNumber }}
                      </p>
                    </div>
                  </div>

                  <div class="total-cost-detail">
                    <div class="total-cost-title text-secondary pr-2">
                      <p class="mb-0">
                        {{ $tc("message.receiptSummarytitle", 2) }}
                      </p>
                      <p class="mb-0">
                        {{
                          Number(receiptDetails.total_points).toLocaleString()
                        }}pts
                      </p>
                    </div>
                    <div class="cost-value text-success">
                      <h3 class="mb-0">
                        ${{
                          receiptDetails.total | formatNumber
                        }}
                      </h3>
                    </div>
                  </div>

                  <!-- Download button -->
                  <div class="row justify-content-center align-items-center">
                    <b-button
                      class="download-button mt-1 mx-0 col-11 px-0 border-warning bg-warning"
                      variant="warning"
                      @click="gotoDownloadReceipt()"
                    >
                      <downloadSvg></downloadSvg>
                      <span class="ml-1">
                        {{ $tc("message.receiptSummarytitles", 0) }}
                      </span>
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- Payments summare ends --->
            </div>
          </div>
        </div>
      </div>
      <receiptDesign :transactionData="receiptDetails" v-show="false" v-if="receiptDetails.managers"></receiptDesign>
      <loader v-if="isLoading === true || showLoader"></loader>
    </div>
    <errors
      v-else
      :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss" scoped>
.receipt-container {
  display: flex;
  flex-direction: column;
  max-height: 77.3vh;
  overflow: auto;
}
.main-header-section {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #e5e5e5;
  padding: 24px;
  align-items: center;
}
.main-header-section-mobile {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #e5e5e5;
  padding: 24px 20px;
}
.purchased-date-text-mobile {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
}
.purchased-date-text {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}
.paypal-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.purchased-by-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.order-summary-container {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-height: 340px;
}
.order-summary-container-mobile {
  margin: 28px 0px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.order-summary-title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #45505b;
  padding-bottom: 24px;
}
.restaurant-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.owner-name-title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #45505b;
}
.order-price-value {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  letter-spacing: 0.1px;
  text-align: right;
  color: #45505b;
}
.owner-name-title-mobile {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.restaurant-points-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 0px;
  max-height: 420px;
}
.restaurant-name-title {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #687888;
}
.restaurant-point-value {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: var(--success);
}
.summary-wrapper {
  display: flex;
  flex-direction: row;
  padding: 12px;
}
.payment-summary-container {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow: auto;
}
.payment-summary-title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #45505b;
  padding-bottom: 24px;
}
.sub-total-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.sub-total-detail-mobile {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.sub-total-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.sub-total-value {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
.fees-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0px;
  align-items: center;
}
.fees-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.fees-value {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
.taxes-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 0px;
  align-items: center;
}
.taxes-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.taxes-value {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
}
.total-cost-detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 7px 0px;
  align-items: center;
}
.total-cost-title {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
.cost-value {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  padding: 12px 0px;
}
.download-button {
  padding: 12px 0px;
  border-radius: 4px;
  border: 1px solid;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.button-container {
  align-items: center;
}
.button-container-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
}
.download-button-mobile {
  padding: 5px 20px;
  border-radius: 4px;
  display: flex;
  min-width: 100%;
  justify-content: center;
  align-items:center;
  border: 1px solid;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--secondary-bg-text) !important;
}

.downloadimg {
  min-width: 28.67px;
  min-height: 28.67px;
  border-radius: 50%;
  top: 2.08%;
  bottom: 2.08%;
  margin-right: 8px;
}
.downloadimg-mobile {
  min-width: 24.67px;
  min-height: 24.67px;
  border-radius: 50%;
}
.sub-total-title-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}
.sub-total-value-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
}
.fees-title-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}
.fees-value-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
}
.taxes-title-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}
.taxes-value-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
}
.total-cost-title-mobile {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}
.cost-value-mobile {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.1px;
  padding: 12px 0px;
}
@media (max-width: 600px) {
  .receipt-container {
    padding: 0px;
    overflow: auto;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .col-lg-8 {
    flex: 0 0 80% !important;
  }
}
@media (max-width: 600px) {
  .receipt-container {
    padding: 0px;
    max-height: 98vh;
    overflow: auto;
  }
}
.receipt-title {
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 38px;
  margin: 0 auto;
  letter-spacing: 0.1925px;
}
.receipt-title-mobile {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  margin: 0 auto;
  padding-top: 15px;
}

@media (max-width: 320px) {
  .receipt-container {
    max-height: 76vh;
  }
}

@media (max-width: 360px) and (min-width: 321px) {
  .receipt-container {
    max-height: 76vh;
  }
}

@media (max-width: 414px) and (min-width: 361px) {
  .receipt-container {
    max-height: 76vh;
  }
}
@media (min-width: 370px) and (max-width: 375px) {
  .receipt-container {
    max-height: 76vh;
  }
}
@media (max-width: 540px) and (min-width: 500px) {
  .receipt-container {
    max-height: 76vh;
  }
}
@media (max-height: 736px) and (min-height: 731px) {
  .receipt-container {
    max-height: 78vh;
  }
}
@media (min-height: 800px) and (max-height: 823px) {
  .receipt-container {
    max-height: 67vh;
  }
}
.btn:active,
.btn:focus,
.btn.active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.bg-warning {
  background: var(--secondary-bg) !important;
  color: var(--secondary-bg-text) !important;
  border-color: var(--secondary-bg) !important;
}
a.bg-warning:hover,
a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: var(--button-hover-bg) !important;
  color: var(--button-hover-bg-text) !important;
  border-color: var(--button-hover-bg) !important;
}
.summary-card {
  padding: 12px;
}
</style>